import { ActionTypes } from './types';

export const removeConfigurationFromList = (configurationCode) => ({
  type: ActionTypes.REMOVE_CONFIGURATION_FROM_LIST,
  configurationCode,
});

export const removeUserImageForConfiguration = (configurationCode) => ({
  type: ActionTypes.REMOVE_USER_IMAGE_FOR_CONFIGURATION,
  configurationCode,
});

export const setUserImageForConfiguration = (configurationCode, file) => ({
  type: ActionTypes.SET_USER_IMAGE_FOR_CONFIGURATION,
  configurationCode,
  file,
});

export const setContextMenuState = (payload: object) => ({
  type: ActionTypes.SET_CONTEXT_MENU_STATE,
  payload,
});

export const setClickToAddDoorHintState = (payload: object) => ({
  type: ActionTypes.SET_CLICK_TO_ADD_DOOR_HINT_STATE,
  payload,
});
